// extracted by mini-css-extract-plugin
module.exports = {"layeredImage":"layeredImage_layeredImage__NyvCJ"};